import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackLinkService } from './back-link.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-nav',
  standalone: true,
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss'],
  imports: [
    CommonModule
  ]
})
export class MobileNavComponent {
  constructor (
    private backLink: BackLinkService,
    private router: Router,
  ) {}

  @Input() isEmit: boolean = false;
  @Input() inverse: boolean = false;
  @Input() flow: boolean = false;

  @Output() back: EventEmitter<unknown> = new EventEmitter<unknown>()

  onBack(): void {
    if (this.isEmit) {
      this.back.emit();
      return;
    }
    void this.router.navigate([this.backLink.backLink]);
  }
}
